<script>
	// Trusted, repository-owned HTML; never pass content from an API or a user.
	let { content } = $props();
</script>

<div class="ios-legal-copy" lang="en" dir="ltr">
	{@html content}
</div>

<style>
	.ios-legal-copy { line-height: 1.7; overflow-wrap: anywhere; }
	.ios-legal-copy :global(p) { margin-block: 0 1rem; }
	.ios-legal-copy :global(h2), .ios-legal-copy :global(h3) {
		font-size: 1.25rem; line-height: 1.35; margin-block: 2rem 0.75rem;
		color: var(--text-color); scroll-margin-top: 1rem;
	}
	.ios-legal-copy :global(a) { color: var(--accent-text); text-decoration: underline; text-underline-offset: 3px; }
	.ios-legal-copy :global(a:focus-visible) { outline: 2px solid var(--accent-text); outline-offset: 4px; }
	.ios-legal-copy :global(.features) { margin-block: 1rem 1.5rem; }
	.ios-legal-copy :global(.features > div) { border-block-end: 1px solid var(--border-color); padding-block: 1rem; }
	.ios-legal-copy :global(dt) { font-weight: 650; margin-block-end: 0.35rem; }
	.ios-legal-copy :global(dd) { margin: 0; }
</style>
